// extracted by css-extract-rspack-plugin
export default {"sizeFluid":"100%","loader":"signup-container__loader___wnJyy"};